import { h, Component } from 'preact';
import { accessNested, joinClasses } from 'utils/utils';
import { track } from 'utils/tracking';
import { replaceWithVNode } from 'utils/vnode';
import Store from 'store/store';
import * as actions from 'store/actions';
import s from 'components/shared/youtube/youtube.sss';


export default class YoutubePlayer extends Component {

	constructor(props) {
		super(props);
		this.progressTracking = {};
		//this.iframeId = props.activeItem ? props.activeItem.ytid : 'youtubeIframe';
		this.iframeId = this.generateId(props.activeItem ? (props.activeItem.ytid || props.activeItem.playlistId) : 'youtubeIframe');
		this.loadPlayer = this.loadPlayer.bind(this);
		this.toggleMute = this.toggleMute.bind(this);
		this.showCookieModal = this.showCookieModal.bind(this);
		this.getProgress = this.getProgress.bind(this);
		this.onStateChange = this.onStateChange.bind(this);
		this.onPlayerReady = this.onPlayerReady.bind(this);
		this.setProgress = this.setProgress.bind(this);
		this.togglePlay = this.togglePlay.bind(this);
		this.play = this.play.bind(this);
		this.pause = this.pause.bind(this);
		this.playlistIndex = props.activeItem && props.activeItem.playlistId ? 0 : false;
		this.isClosableTrailer = this.props.tracking === 'closing-trailer';
		this.firstPlay = true;
		this.YTPlayer = false;
		this.trackFullscreenOpen = this.trackFullscreenOpen.bind(this);
		this.cookiesCheck = accessNested(Store.get(), 'appData.options.cookiesModal');
		this.landscapeDisabled = accessNested(Store.get(), 'appData.options.disableLandscape');
		this.state = {
			fullscreen: false,
			waitingForCookies: this.cookiesCheck
		};
		this.appData = props.appData || Store.get().appData;
	}

	componentDidMount() {
		if (!this.cookiesCheck || window.preventCookies === false) {
			if (this.cookiesCheck) {
				this.setState({ waitingForCookies: false });
			}
			this.initYoutube();
		}
		document.addEventListener("fullscreenchange", this.trackFullscreenOpen, false);
		document.addEventListener("webkitfullscreenchange", this.trackFullscreenOpen, false);
		document.addEventListener("mozfullscreenchange", this.trackFullscreenOpen, false);
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.waitingForCookies) {
			if (window.preventCookies === false) {
				this.setState({ waitingForCookies: false });
				this.initYoutube();
			}
			return;
		}

		// let isMobile = accessNested(nextProps, 'client.deviceSize') !== 'desktop';
		// let mextOrientation = accessNested(nextProps, 'client.orientation');
		// let currentOrientation = accessNested(this.props, 'client.orientation');
		// let disableLandscape = accessNested(this.appData, 'options.disableLandscape');
		// if (mextOrientation === 'landscape' && currentOrientation !== mextOrientation && isMobile && disableLandscape) {
		// 	this.pause();
		// }

		const active = this.props.activeItem;
		const nextActive = nextProps.activeItem;

		if (nextActive && !active && !this.YTPlayer) {
			if (window.YT) this.loadPlayer(nextActive);
			else this.initYoutube();
			return;
		}

		if (nextActive != active && (!active || !nextActive || Object.entries(nextActive).find(([key, value]) => value !== active[key]))) {
			this.oldYTid = active.ytid;
			this.updateActiveItem(nextActive);
		}

		if (nextProps.playing !== this.props.playing && this.YTPlayer && !this.firstPlay) {
			this.YTPlayer[nextProps.playing ? 'playVideo' : 'pauseVideo']();
		}
	}

	shouldComponentUpdate(props, state) {
		let update = this.state.waitingForCookies !== state.waitingForCookies;
		return update;
	}

	componentWillUnmount() {
		clearInterval(this.timer);
		document.removeEventListener('fullscreenchange', this.trackFullscreenOpen, false);
		document.removeEventListener('webkitfullscreenchange', this.trackFullscreenOpen, false);
		document.removeEventListener('mozfullscreenchange', this.trackFullscreenOpen, false);
	}

	trackYT(trackObj) {
		track(trackObj);
		if (this.props.tracking) {
			track({
				...trackObj,
				a: this.props.tracking + '-' + trackObj.a //Prepend the tracking string so we have specifc tracking for that video
			});
		}
	}

	trackFullscreenOpen() {
		const { deviceSize, orientation } = this.props.client;
		const isMobileLandscape = deviceSize === 'mobile' && orientation === 'landscape';

		if (this.state.fullscreen && isMobileLandscape && this.landscapeDisabled && this.YTPlayer) {
			this.YTPlayer.pauseVideo();
		}
		this.setState({ fullscreen: !this.state.fullscreen });

		if(this.state.fullscreen){
			this.trackYT({ a: 'yt-video-fullscreen-open', l: (this.props.activeItem.ytid || this.props.activeItem.playlistId) });
		} else {
			this.trackYT({ a: 'yt-video-fullscreen-closed', l: (this.props.activeItem.ytid || this.props.activeItem.playlistId) });
		}
	}

	generateId(baseId) {
		// Generates an element id that is not already on the page
		// For example if you give it 'myID' it will return 'myID' unless it's already on the page
		// in which case it will return 'myID2' (and then 'myID3' etc.)
		baseId = baseId || 'youtube';
		if (typeof document === 'undefined') {
			return baseId;
		}
		let id = baseId;
		let i = 1;
		while (document.getElementById(id)) {
			id = baseId + (++i);
		}
		return id;
	}

	initYoutube() {
		if (typeof window === 'undefined' || this.initOnce) {
			return;
		}
		this.initOnce = true;
		if (window.YT && (window.YT.Player || window.YT.loaded === 0)) {
			return this.loadPlayer(this.props.activeItem);
		}
		if (window.YTloading) {
			return window.YTloading.then(() => this.loadPlayer(this.props.activeItem));
		}
		window.YTloading = new Promise(resolve => {
			window.onYouTubeIframeAPIReady = () => setTimeout(resolve, 0);
			const tag = document.createElement('script');
			tag.src = 'https://www.youtube.com/iframe_api';
			document.body.appendChild(tag);
		}).then(() => {
			window.YTloading = false;
			this.loadPlayer(this.props.activeItem);
		}).catch(e => {
			Store.emit(actions.API_ERROR, 'Youtube', e);
			console.error('err', e);
		});
	}

	loadPlayer(activeItem) {
		let {
			autoplay = true,
			client = {},
			showInfo = true,
			delay = 0,
			customDesktopUI,
			ccLoadPolicy = false
		} = this.props;

		const {
			deviceSize = "mobile"
		} = client;

		const youtubeNoCookies = accessNested(Store.get(), 'appData.meta.youtubeNoCookies', false) || this.props.noCookies;

		const YT = window.YT;
		if (typeof YT.Player !== 'function' || !activeItem) {
			// console.error('YT.player is not a function, or activeItem does not exist', YT.Player, activeItem);
			return;
		}
		// a recent update to the youtube embeds makes it so that the watch later button over laps the mute button unless
		// if show info is enabled.. the mute and full screen icons are a part of the controls tab and out of the way.. Killian
		// default to 1 if not desktop
		showInfo = deviceSize === "desktop" ? (showInfo ? 1 : 0) : 1;
		const isSmallDesktop = client.dimensions && client.dimensions.width < 1025;
		const options = {
			height:     isSmallDesktop ? '504' : '576',
			width:      isSmallDesktop ? '896' : '1024',
			playerVars: {
				autoplay:         autoplay ? 1 : 0,
				rel:              0,
				showinfo:         showInfo,
				suggestedQuality: 'large',
				enablejsapi:      1,
				playsinline:      1,
				cc_load_policy:   ccLoadPolicy ? 1 : 0,
				origin: window.location.host
			},
			events: {
				onReady:       this.onPlayerReady,
				onStateChange: this.onStateChange,
				onError:       this.onError
			}
		};

		if (youtubeNoCookies) {
			options.host = 'https://www.youtube-nocookie.com';
		}

		if (customDesktopUI) {
			options.playerVars.iv_load_policy = 3;
			// Doesn't work with showinfo = 0
			// options.playerVars.modestbranding = 1;
			options.playerVars.controls = 0;
			options.playerVars.showinfo = 0;
		}

		if (activeItem.ytid) {
			options.videoId = activeItem.ytid.replace(/\s/g,'');
		} else if (activeItem.playlistId) {
			options.playerVars.listType = 'playlist';
			options.playerVars.list     = activeItem.playlistId;
		}

		let ready = () => {
			if (this.YTPlayer) return;

			this.YTPlayer = new YT.Player(this.iframeId, options);
			YT.activePlayer = this.YTPlayer;
		};
		if (delay) {
			setTimeout(ready, delay);
		} else {
			ready();
		}
	}

	togglePlay() {
		if (!this.YTPlayer) return;
		if (this.playing) {
			this.YTPlayer.pauseVideo();
		} else {
			this.YTPlayer.playVideo();
		}
	}

	play() {
		if (!this.YTPlayer) return;
		if (this.playing) return;
		if (typeof this.YTPlayer.playVideo === 'function') {
			this.YTPlayer.playVideo();
		}
		this.trackYT({ a: `yt-video-play-${this.props.activeItem.ytid}`, l: (this.props.activeItem.ytid || this.props.activeItem.playlistId) });
	}

	pause() {
		if (!this.YTPlayer) return;
		if (this.playing === false) return;
		this.YTPlayer.pauseVideo();
		this.manuallyPaused = true;
		this.trackYT({ a: `yt-video-pause-${this.props.activeItem.ytid}`, l: (this.props.activeItem.ytid || this.props.activeItem.playlistId) });
	}

	toggleMute() {
		const currentMute = this.YTPlayer.isMuted();
		if (currentMute) {
			this.YTPlayer.unMute();
		} else {
			this.YTPlayer.mute();
		}

		if (typeof this.props.onMuteChange === 'function') {
			this.props.onMuteChange(!currentMute);
		}
	}

	setProgress(progress) {
		this.YTPlayer.seekTo(progress);
	}


	onPlayerReady(event) {
		const {
			onPlayerReady,
			muted
		} = this.props;

		if (typeof onPlayerReady === 'function') {
			// call the on player ready functionality
			// (this can be used to see if the browser supports the youtube player)
			onPlayerReady(event);
			Store.emit(actions.YOUTUBE_READY, this.props.activeItem.ytid);
		}
		this.timer = setInterval(this.getProgress, 50);
		if (muted) {
			event.target.mute();
		}
	}

	onError(error) {
		Store.emit(actions.API_ERROR, 'Youtube', error);
	}

	getProgress() {
		if (this.YTPlayer && this.YTPlayer.getCurrentTime) {
			const currentTime = this.YTPlayer.getCurrentTime();
			const videoLength = this.YTPlayer.getDuration();
			const playerData = this.YTPlayer.getVideoData();
			const progress = currentTime / videoLength;

			if (this.playing) {
				this.fireFirstPlay(this.YTPlayer);
			}
			let step = [25, 50, 75, 95].find(step => progress > step / 100 && !this.progressTracking[step]);
			if (step) {
				this.progressTracking[step] = true;
				if (step !== 95) {
					this.trackYT({ a: `yt-video-${this.props.activeItem.ytid}-duration-${step}%`, l: (this.props.activeItem.ytid || this.props.activeItem.playlistId) });
				}
				Store.emit(actions.YOUTUBE_PROGRESS, step, this.props.activeItem.ytid || this.props.activeItem.playlistId, videoLength, playerData, this.isClosableTrailer);
			}

			if (typeof this.props.onProgress === 'function') {
				this.props.onProgress(progress, currentTime, videoLength);
			}
		}
	}

	stateChangedEnd() {
		// Function for overrides
		// will get called when the state of the video changes to ended
	}

	stateChangedPlay() {
		// Function for overrides
		// will get called when the state of the video changes to play
	}

	stateChangedPause() {
		// Function for overrides
		// will get called when the state of the video changes to paused
	}

	stateChangedBuffering() {
		// Function for overrides
		// will get called when the state of the video changes to buffering
	}

	onStateChange(state) {
		// State meanings:
		// -1 (unstarted)
		// 0 (ended)
		// 1 (playing)
		// 2 (paused)
		// 3 (buffering)
		// 5 (video cued).
		this.playing = false;
		if (!this.YTPlayer || !this.YTPlayer.getDuration || !this.YTPlayer.getVideoData || !this.YTPlayer.getCurrentTime) {
			return;
		}

		const videoLength = this.YTPlayer.getDuration();
		const playerData = this.YTPlayer.getVideoData();
		const playhead = this.YTPlayer.getCurrentTime();
		switch (state.data) {
			case 0:
				// ENDED
				let playlistLength = 0;
				if (this.playlistIndex !== false) {
					this.playlistIndex++;
					let playlist = this.YTPlayer && this.YTPlayer.getPlaylist();
					if (playlist && playlist.length) {
						playlistLength = playlist.length;
					}
				}
				if (!playlistLength) {
					this.fireVideoEnded();
				}
				// Add in possibility for extra functionality
				this.stateChangedEnd();
				break;

			case 1:
				// PLAYING
				this.playing = true;
				// clear the old id once playing
				// we need this id to clear certain trackers on pause, as this.props will already have the new id
				delete this.oldYTid;
				// TODO: what about playlistId?
				this.playId = this.props.activeItem.ytid;
				let id = this.props.activeItem.ytid || this.props.activeItem.playlistId;
				// incorrect, will fire a start if the user pauses and play before 1 second
				//   should check if this is the first fire or something like that
				if (playhead < 1) {
					this.trackYT({ a: `yt-video-started-${id}`, l: id });
					this.progressTracking = {};
				} else {
					Store.emit(actions.YOUTUBE_PLAY, { id: id }, videoLength, playhead, playerData);
					this.trackYT({ a: `yt-video-play-${id}`, l: id });
				}
				if (typeof this.props.onPlay === 'function') {
					this.props.onPlay();
				}
				this.fireFirstPlay(this.YTPlayer);

				// Add in possibility for extra functionality
				this.stateChangedPlay();
				break;

			case 2:
				if (this.playId !== this.props.activeItem.ytid) {
					// Pause is occuring because the video is switched to a new one
					this.playId = this.props.activeItem.ytid;
				} else {
					// video is actually being paused
					Store.emit(actions.YOUTUBE_PAUSE, videoLength, playhead, playerData);
					this.trackYT({ a: `yt-video-paused-${this.props.activeItem.ytid}`, l: (this.props.activeItem.ytid || this.props.activeItem.playlistId) });
				}

				// PAUSE
				if (typeof this.props.doneClicked === 'function' && (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)) {
					// this.props.doneClicked();

				}
				if (typeof this.props.onPause === 'function') {
					this.props.onPause();
				}
				// Add in possibility for extra functionality
				this.stateChangedPause();
				break;

			case 3:
				// Add in possibility for extra functionality
				this.stateChangedBuffering();
				break;

			case 5:
				break;
		}

		if (typeof this.props.onStateChange === 'function') {
			this.props.onStateChange(this.playing, state.data);
		}

		// Use for added logic in override components
		this.extendedStateChange(state);

	}

	extendedStateChange = () => {}

	updateActiveItem(activeItem) {
		if (this.YTPlayer.loadVideoById && activeItem.ytid) {
			this.YTPlayer.loadVideoById(activeItem.ytid);
		}
	}

	fireVideoEnded() {
		const videoLength = this.YTPlayer.getDuration();
		const playerData = this.YTPlayer.getVideoData();
		this.trackYT({ a: `yt-video-ended-${this.props.activeItem.ytid}`, l: (this.props.activeItem.ytid || this.props.activeItem.playlistId) });
		if (typeof this.props.onVideoEnded === 'function') {
			this.props.onVideoEnded(this.YTPlayer, true);
		}
		Store.emit(actions.YOUTUBE_PROGRESS, 100, this.props.activeItem.ytid || this.props.activeItem.playlistId, videoLength, playerData, this.isClosableTrailer);
		Store.emit(actions.YOUTUBE_ENDED);
	}

	fireFirstPlay = () => {
		const videoLength = this.YTPlayer.getDuration();
		const playerData = this.YTPlayer.getVideoData();
		if (this.firstPlay && typeof this.props.onFirstPlay === 'function') {
			this.props.onFirstPlay(this.YTPlayer);
			this.firstPlay = false;
		}
		if (this.firstPlay) {
			Store.emit(actions.YOUTUBE_PROGRESS, 0, this.props.activeItem.ytid || this.props.activeItem.playlistId, videoLength, playerData, this.isClosableTrailer);
			this.firstPlay = false;
		}
	}

	showCookieModal() {
		Store.emit(actions.SHOW_COOKIES_MODAL);
	}

	render(props) {
		const {
			HTMLTag = "div",
			class: className = "",
			iframeClass,
			maintainAspectRatio = false,
			children,
			client
		} = props;

		if (this.landscapeDisabled && this.YTPlayer) {
			if (client.orientation === 'landscape') {
				if (this.playing) {
					this.playingBeforeOrientationChange = true;
					this.YTPlayer.pauseVideo();
				}
			} else {
				if (this.playingBeforeOrientationChange){
					this.playingBeforeOrientationChange = false;
					this.YTPlayer.playVideo();
				}
			}
		}


		const player = (
			<div key="player" id={this.iframeId} class={iframeClass} ref={ref => this.$iframe = ref} />
		);

		// const wrapperClasses = (fullscreen ? s.wrapperFull : s.wrapper) + condClass(wrapperClass);
		const wrapperClasses = s.playerWrapper;

		let cookiesMessage;
		if (this.state.waitingForCookies) {
			let appData = this.appData || {};
			let copy = appData.copy || {};
			let msg = copy.$YOUTUBE_NO_COOKIES || '';
			msg = replaceWithVNode(msg, '%ALLOW_LINK%', (
				<button class={s.allowCookies} onClick={this.showCookieModal}>{copy.$YOUTUBE_NO_COOKIES_ALLOW}</button>
			));
			cookiesMessage = (
				<div class={s.cookiesMessage} key="cookies">{msg}</div>
			);
		}

		return (
			<HTMLTag class={joinClasses(className, wrapperClasses)} ref={ref => this.$wrapper = ref}>
				{maintainAspectRatio ? <div class={s.maintain} key="maintain">{player}</div> : player}
				{/* controls */}
				{children}
				{cookiesMessage}
			</HTMLTag>
		);
	}

}
